<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Coparn</h3>
            </div>
        </div>
        <div class="row">
            <div v-show="lineas.length > 1" class="col-xs-12 col-md-4">
                <div class="form-field select2">
                    <div class="select2-field">
                        <v-select @input="inputLinea" :options="lineas" label="name" id="linea" placeholder="Seleccione..." v-model="selectedLinea"></v-select>
                        <label for="linea">Línea</label>
                        <span v-if="errores.linea_id" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.linea_id[0] }}</strong>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <div class="datepicker-field">
                        <date-picker type="date" id="date_booking" v-model="form.date_booking"></date-picker>
                        <label>F. Booking</label>
                        <span v-if="errores.date_booking" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.date_booking[0] }}</strong>
                        </span>
                    </div>
                </div>
            </div>
            <div  class="col-xs-12 col-md-4">
                <div class="form-field select2" :class="{
                    'select2--disabled' : tipoFormulario !== 'N'
                }">
                    <div class="select2-field">
                        <v-select taggable :options="exportadores" id="exportador" placeholder="Seleccione..." v-model="form.exportador"></v-select>
                        <label for="exportador">Exportador</label>
                        <span v-if="errores.exportador" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.exportador[0] }}</strong>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field :readonly="tipoFormulario !== 'N'" id="booking" v-model="form.booking" placeholder="# Booking">
                        <span>Booking</span>
                        <span v-if="errores.booking" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.booking[0] }}</strong>
                        </span>
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="booking_count" v-model="form.booking_count" placeholder="#######">
                        <span>Booking count</span>
                        <span v-if="errores.booking_count" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.booking_count[0] }}</strong>
                        </span>
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="vessel" v-model="form.vessel" placeholder="###">
                        <span>Vessel</span>
                        <span v-if="errores.vessel" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.vessel[0] }}</strong>
                        </span>
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="voyage" v-model="form.voyage" placeholder="###">
                        <span>Voyage</span>
                        <span v-if="errores.voyage" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.voyage[0] }}</strong>
                        </span>
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="temperature" v-model="form.temperature" placeholder="###">
                        <span>Temperatura</span>
                        <span v-if="errores.temperature" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.temperature[0] }}</strong>
                        </span>
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="ventilation" v-model="form.ventilation" placeholder="###">
                        <span>Ventilación</span>
                        <span v-if="errores.ventilation" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.ventilation[0] }}</strong>
                        </span>
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field select2">
                    <div class="select2-field">
                        <v-select label="address" @input="inputYard" :options="yards" id="yard_code" placeholder="Seleccione..." v-model="selectedYard"></v-select>
                        <label for="yard_code">Patio</label>
                        <span v-if="errores.yard_code" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.yard_code[0] }}</strong>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field select2">
                    <div class="form-group">
                        <div class="select-field">
                            <select :disabled="tipoFormulario !== 'N'" v-model="form.size_container" name="size_container" id="size_container">
                                <option value="40">40</option>
                                <option value="20">20</option>
                            </select>
                            <label for="tipo_contenedor">T. Contenedor</label>
                        </div>
                        <div class="select2-field">
                            <v-select @input="inputType" :options="tiposContenedor" label="descripcion" id="tipo_contenedor" placeholder="Seleccione..." v-model="selectedType"></v-select>                      
                            <span v-if="errores.type" class="helper-text text-danger" slot="helper">
                                <strong>{{ errores.type[0] }}</strong>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="remark" v-model="form.remark" placeholder="#######">
                        <span>Remark</span>
                        <span v-if="errores.remark" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.remark[0] }}</strong>
                        </span>
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="location_receipt" v-model="form.location_receipt" placeholder="#######">
                        <span>Localización</span>
                        <span v-if="errores.location_receipt" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.location_receipt[0] }}</strong>
                        </span>
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="marca" v-model="form.marca" placeholder="#######">
                        <span>Marca</span>
                        <span v-if="errores.marca" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.marca[0] }}</strong>
                        </span>
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="oxigeno" v-model="form.oxigeno" placeholder="#######">
                        <span>Oxígeno</span>
                        <span v-if="errores.oxigeno" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.oxigeno[0] }}</strong>
                        </span>
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="dioxido_carbono" v-model="form.dioxido_carbono" placeholder="#######">
                        <span>Dióxido de carbono</span>
                        <span v-if="errores.dioxido_carbono" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.dioxido_carbono[0] }}</strong>
                        </span>
                    </input-field>
                </div>
            </div>
        </div>
        <div class="modal-buttons">
            <button @click="guardar" class="btn-success" type="button">
                <i class="fa fa-save"></i> <span>Guardar</span>
            </button>
            <button type="button" @click="$emit('cancelar')" class="btn-danger btn--text"><i class="fa fa-ban"></i><span>Cancelar</span></button>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        tipoFormulario : {
            type : String,
            required : false,
            default : 'N'
        },
        value : {
            type : Object,
            required : false,
            default : function () {
                return {
                    booking : '',
                    date_booking : moment(new Date()).format('YYYY-MM-DD'),
                    vessel : '',
                    voyage : '',
                    temperature : '', 
                    linea_id : '',
                    type : '', 
                    size_container : '40', 
                    exportador : '', 
                    yard_code : '', 
                    booking_count : 0,
                    remark : '', 
                    location_receipt : '',
                    _method : undefined,
                    ventilation : '',
                    oxigeno: '',
                    dioxido_carbono: '',
                    marca: ''
                };
            }
        },
        exportadores : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        },
        tiposContenedor : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        },
        yards : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        },
        telefonos : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        },
        lineas : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        }
    },
    data : function () {
        return {
            form : this.value,
            errores : {},
            selectedLinea : null,
            selectedType : null,
            selectedYard : null
        };
    },
    methods : {
        inputYard : function () {
            if (this.selectedYard !== null)
                this.form.yard_code = this.selectedYard.code;
            else 
                this.form.yard_code = '';
        },
        inputType : function () {
            if (this.selectedType !== null)
                this.form.type = this.selectedType.code;
            else 
                this.form.type = '';
        },
        guardar : function () {
            let that = this;
            swal({
                    title: '¿Desea almacenar los datos ingresados?',
                    type: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Aceptar',
                    cancelButtonText : 'Cancelar'
                    }).then((result) => {
                        if (result.value) {
                            if (that.tipoFormulario === 'E')
                                that.form._method = 'PUT';
                            else 
                                that.form._method = undefined;
                            axios.post(url + '/coparn' + (that.tipoFormulario === 'N'?'':'/' + that.form.booking), that.form).then(function (response) {
                                swal('Los datos fueron almacenados.', 'Realizado', 'success');
                                that.$emit('saved');
                            }).catch(function (error) {
                                if (error !== null && error !== undefined) {
                                    let response = error.response;
                                    if (response !== undefined && response !== null) {
                                        let status = response.status;
                                        if (status === 422) 
                                        {
                                            that.errores = response.data.errors;
                                            swal('Hay errores en el formulario.', 'Aviso', 'warning');
                                            return;
                                        }
                                    }
                                }
                                swal('Hubo un error, intente nuevamente.', 'Error', 'error');
                            });
                        }
                    });
        },
        inputLinea : function () {
            this.form.linea_id = this.selectedLinea.code;
        }
    },
    mounted : function () {
        if (this.lineas.length === 1) {
            this.selectedLinea = this.lineas[0];
            this.inputLinea();
        }
        else {
            let that = this;
            for (let i = 0; i < this.lineas.length; i++)
                if (this.lineas[i].code == this.form.linea_id) {
                    this.selectedLinea = this.lineas[i];
                    break;
                }
        } 
        if (this.form.type != null && this.form.type !== '')
            for (let i = 0; i < this.tiposContenedor.length; i++)
                if (this.tiposContenedor[i].code == this.form.type) {
                    this.selectedType = this.tiposContenedor[i];
                    break;
                }
        if (this.form.yard_code != null && this.form.yard_code !== '') 
            for (let i = 0; i < this.yards.length; i++) {
                if (this.yards[i].code == this.form.yard_code) {
                    this.selectedYard = this.yards[i];
                    break;
                }
            }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/ecas-coparn/Coparn.vue